import React from 'react';

import './ErrorBoundary.scss';

const blockName = 'error-boundary';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  state = {
    hasError: false,
  };

  render() {
    return this.state.hasError ? (
      <div className={blockName}>
        <div className={`${blockName}__sidebar`} />
        <div className={`${blockName}__message-wrapper`}>
          <h1>Something went wrong, please try again later</h1>
          <p>
            We're aware of the problem and we are working ont it. Sorry for the
            invonceniences
          </p>
          <a href={window.location.origin}>Login again</a>
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
